import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=929c732e&scoped=true"
import script from "./pieChart.vue?vue&type=script&lang=js"
export * from "./pieChart.vue?vue&type=script&lang=js"
import style0 from "./pieChart.vue?vue&type=style&index=0&id=929c732e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929c732e",
  null
  
)

export default component.exports